<template>
  <div class="pageFooter">
    <stripes />
    <share />
  </div>
</template>
<script>
import Stripes from './Stripes.vue';
import Share from './Share.vue';

export default {
  components: {
    Stripes,
    Share,
  },
};
</script>

<style lang="scss" scoped>
.pageFooter {
  width: 100%;
  display: flex;
  flex-direction: column;
  @include tablet {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 40px;
    height: 40px;
    overflow: hidden;
  }
}
</style>
